import { DOCUMENT } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { finalize, map, tap } from "rxjs/operators";

import { GrowlService } from "@lantern/app/core";

import { GlobalAuthService } from "@local/app/core/global-auth";
import { Mart } from "@local/app/models";

@Component({
  selector: "ta-lcl-marts",
  templateUrl: "marts.template.html"
})
export class MartsComponent implements OnInit {
  marts$: Observable<Mart[]>;

  windowRef: Window;

  constructor(
    private globalAuthService: GlobalAuthService,
    private growlService: GrowlService,
    @Inject(DOCUMENT) documentRef: any
  ) {
    this.windowRef = (documentRef as Document).defaultView!;
  }

  ngOnInit(): void {
    this.initMarts$();
  }

  private initMarts$(): void {
    this.marts$ = this.globalAuthService.getMarts().pipe(
      tap((marts) => {
        if (marts.length === 1) {
          this.windowRef.location.href = `//${marts[0].domain}`;
        }

        if (marts.length === 2) {
          const domainsByKeys: Record<string, string> = marts.reduce(
            (accum, { key, domain }) => ({ ...accum, [key]: domain }),
            {}
          );

          // redirect DCS users who also have access to standalone activations but shouldn't be able to see it
          if (
            domainsByKeys["tapad-dcs-prd"] != null &&
            domainsByKeys["tapad-standalone-activations"] != null
          ) {
            this.windowRef.location.href = `//${domainsByKeys["tapad-dcs-prd"]}`;
          }
        }
      }),
      map((marts) =>
        marts.sort((mart1, mart2) => (mart1.name < mart2.name ? -1 : 1))
      ),
      map((marts) =>
        marts.map((mart) => ({
          ...mart,
          href: `https://${mart.domain}`
        }))
      )
    );
  }

  loggingOut: boolean = false;
  logout(): void {
    if (this.loggingOut) {
      return;
    }

    this.loggingOut = true;
    this.globalAuthService
      .logout()
      .pipe(finalize(() => (this.loggingOut = false)))
      .subscribe(
        () => this.growlService.success("Logged out!"),
        () => this.growlService.danger("Error logging out.")
      );
  }
}
